var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStyle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.6,6.4c-0.5-0.5-1.4-0.5-1.9,0L7,13.1C6,14.1,6,15.8,7,16.9l4.8,4.8c1.1,1.1,2.8,1.1,3.8,0l7.2-7.2 c0.3-0.3,0.3-0.7,0-1L15.6,6.4z M14.5,7.7l-5.1,5.1c-0.2,0.2-0.1,0.4,0.2,0.5l11.1,0.9c0.2,0,0.4-0.3,0.2-0.5l-6-6 C14.7,7.6,14.6,7.6,14.5,7.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.5,16c0.1-0.2,0.4-0.2,0.5,0l1.5,3c0.6,1.3-0.3,2.8-1.7,2.8S21.3,20.3,22,19L23.5,16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.9,24.1c-0.6,0-1,0.5-1,1s0.5,1,1,1h20.2c0.6,0,1-0.5,1-1s-0.5-1-1-1H5.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyle);
export default __webpack_public_path__ + "static/media/style.e0b328b6ccaaa368bc500d9162de904c.svg";
export { ForwardRef as ReactComponent };